<template>
  <v-navigation-drawer v-if="showSidebar" left v-model="customizer.Sidebar_drawer" elevation="0" rail-width="70"
    mobile-breakpoint="sm" app class="leftSidebar bg-mycolor" :rail="customizer.mini_sidebar">
    <!-- Logo part, hidden in mini sidebar but space remains -->
    <div class="logo-container" :class="{ collapsed: customizer.mini_sidebar }">
      <NuxtLink to="/dashboard">
        <img src="/smcLogo.svg" alt="SMC Logo" class="logo" />
        <!-- <img src="/Data Centre.svg" alt="Data Centre" class="logo-Data-Centre" /> -->
      </NuxtLink>
    </div>

    <!-- Navigation items -->
    <v-list  aria-busy="true" class="px-2" aria-label="menu list">
      <template v-for="(item, i) in sidebarMenu" :key="i">

        <v-divider v-if="item.divider" />
        <SidebarNavItem  v-else :item="item"  />

      </template>

    </v-list>

    <template v-slot:append v-if="!customizer.mini_sidebar">
      <div class="d-flex justify-center pa-4">
        <v-menu :close-on-content-click="false" offset="8, 0">
          <template v-slot:activator="{ props }">
            <v-btn class="w-100 profileBtn mr-0 d-flex align-center justify-center" aria-label="profile" variant="tonal"
              rounded="lg" style="padding: 20px; background-color: #40403f; color: white" v-bind="props">
              <v-icon size="30" class="mr-2">mdi-account-circle</v-icon>
              <span class="ml-2" style="font-weight: 500; font-size: 16px">{{ user.name }}</span>
            </v-btn>
          </template>

          <v-sheet rounded="md" width="350">
            <ProfileDD />
          </v-sheet>
        </v-menu>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
  import { shallowRef } from "vue";
  import { useCustomizerStore } from "@/stores/customizer";
  import sidebarItems from "././sidebarItem";
  import { useTenant } from "~/composables/useTenant";
  import { useUser } from "~/composables/useUser";
  import ProfileDD from "././ProfileDD.vue";

  const customizer = useCustomizerStore();
  const sidebarMenu = shallowRef(sidebarItems);
  const user = await useUser();
 
  const open = ref([]);

const tenant = await useTenant();
const showSidebar = computed(() => {
  const modules = tenant.value?.modules || [];
  return !(modules.length === 1 && modules.includes("Birdnest"));
});

onMounted(async () => {
  if (window.innerWidth < 600) {
    customizer.Sidebar_drawer = false;
  }
});


</script>

<style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap");


  /* Sidebar content, ensuring the layout remains unchanged */
  .logo-container {
    padding: 20px;
    text-align: center;
  }

  .logo {
    width: 200px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    /* margin-top: 10px; */
  }

  .logo-Data-Centre {
    width: 120px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 10px;
  }

  .logo-container.collapsed {
    visibility: hidden;
    height: 120px;
  }

  .v-navigation-drawer {
    font-family: "Nunito Sans", sans-serif;
  }

  .bg-mycolor {
    background-color: #f5f5f5;
  }
</style>
